/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { BadRequestResultDto, ErrorHttpContentDto } from "../";
import { HttpClient, RequestParams } from "./http-client";

@Injectable()
export class WarmupClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags Warmup
   * @name WarmupGet
   * @summary Warmup Action
   * @request GET:/warmup
   */
  warmupGet = (params: RequestParams = {}) =>
    this.http.request<string, BadRequestResultDto | ErrorHttpContentDto>({
      path: `/warmup`,
      method: "GET",
      format: "json",
      ...params,
    });
}
